import React from "react";

// Local optimised asset — cropped to content bbox (~3.05:1) with dark-purple
// letters recoloured white for visibility on the #0A0A0A background. Keeps
// the bright purple (#9D00FF) accents exactly as in the brand file.
const LOGO_SRC = "/tabon-logo.png?v=5";

const SIZES = {
  sm: "h-9",
  md: "h-12",
  lg: "h-20",
  xl: "h-28",
};

export function Logo({ size = "md", className = "" }) {
  const hClass = SIZES[size] || SIZES.md;
  return (
    <div
      data-testid="tabon-logo"
      className={`inline-flex items-center ${className}`}
    >
      <img
        src={LOGO_SRC}
        alt="TabOn"
        draggable={false}
        className={`${hClass} w-auto select-none`}
        style={{ objectFit: "contain" }}
      />
    </div>
  );
}
